



































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import Icon from '@/components/common/elements/Icon.vue';
import Label from '@/components/common/elements/Label.vue';
import ComboBoxArea from '@/components/common/modules/ComboBoxArea.vue';
import AddDetails from '@/components/common/modules/AddDetails.vue';
import Button from '@/components/common/elements/Button.vue';
import MultipleLineText from '@/components/common/elements/MultipleLineText.vue';
import InputArea from '@/components/common/modules/InputArea.vue';

import AutoCreateForm from '@/components/form/AutoCreateForm.vue';

@Component({
  components: { SingleText, Icon, Label, ComboBoxArea, AddDetails, Button, MultipleLineText, InputArea, AutoCreateForm },
})
export default class CreateDetailsPanel extends Vue {
  @Prop()
  private DetailFieldData: any;
  @Prop()
  private DetailFieldCols: any;
  @Prop({default: false})
  private isScrren?: boolean;
  @Prop({default: false})
  private isReadOnly?: boolean;
  @Prop()
  private masterData?: any;
  // 編集モード判定制御値
  @Prop({ default: true })
  private isEditMode?: boolean;

  @Prop()
  private parentRegistData: any;

  private registData:any = [];


  /**
   * 明細追加処理
   * 明細配列に新しい行を追加
   * @module addDetailArea
   * @return {void} - メンバ変数の変更
   */
  @Emit('addDetailArea')
  private addDetailArea(){
    return true;
  }

  /**
   * 明細削除時の処理
   * 明細配列から指定行削除
   * @module deleteRow
   * @param {number} index - 削除対象の配列番号
   * @return {void} - メンバ変数の変更
   */
  @Emit('deleteRow')
  private deleteRow(index: number){
    return index;
  }

  private catchInput(response: any) {
    const name = response.name;
    if (name.startsWith('material_id')) {
      // 材料をマスタ選択した場合、材料名・規格を取り出して設定する
      const idxStr = name.replace('material_id', ''); // 添字を取り出す
      const material = response.value;
      this.catchInputInner({ name: `material_id${idxStr}`, type: 'number', value: material.id });
      this.catchInputInner({ name: `material_name${idxStr}`, type: 'text', value: material.name }, false);
      this.catchInputInner({ name: `standard${idxStr}`, type: 'text', value: material.standard }, false);
      if (this.masterData !== undefined) {
        // 材料マスタのコードから、仕入先を特定
        const supplier = this.masterData['m_supplier'].body.find((v: any) => v.id === material.supplier_id);
        this.catchInputInner({ name: `supplier_id${idxStr}`, type: 'number', value: supplier.id }, false);
        this.catchInputInner({ name: `supplier_name${idxStr}`, type: 'text', value: supplier.name }, false);
      }
    } else if (name.startsWith('material_name') || name.startsWith('standard')) {
      // 材料名・規格が手動入力された場合、材料IDをリセット（数値型なので、-1をセット）する
      const idxStr = name.replace((name.startsWith('material_name') ? 'material_name' : 'standard'), ''); // 添字を取り出す
      this.catchInputInner({ name: `material_id${idxStr}`, type: 'number', value: -1 });
      this.catchInputInner(response, false);
    } else if (name.startsWith('supplier_id')) {
      // 仕入先をマスタ選択した場合、仕入先名を取り出して設定する
      const idxStr = name.replace('supplier_id', ''); // 添字を取り出す
      const supplier = response.value;
      this.catchInputInner({ name: `supplier_id${idxStr}`, type: 'number', value: supplier.id });
      this.catchInputInner({ name: `supplier_name${idxStr}`, type: 'text', value: supplier.name }, false);
    } else if (name.startsWith('supplier_name')) {   
      // 仕入先名が手動入力された場合、仕入先IDをリセット（数値型なので、-1をセット）する
      const idxStr = name.replace('supplier_name', ''); // 添字を取り出す
      this.catchInputInner({ name: `supplier_id${idxStr}`, type: 'number', value: -1 });
      this.catchInputInner(response, false);
    } else if (name.startsWith('subcontractor_id')) {
      // 外注先をマスタ選択した場合、外注先名を取り出して設定する
      const idxStr = name.replace('subcontractor_id', ''); // 添字を取り出す
      const subConstructor = response.value;
      this.catchInputInner({ name: `subcontractor_id${idxStr}`, type: 'number', value: subConstructor.id });
      this.catchInputInner({ name: `subcontractor_name${idxStr}`, type: 'text', value: subConstructor.name }, false);
    } else if (name.startsWith('subcontractor_name')) {
      // 外注先名が手動入力された場合、外注先IDをリセット（数値型なので、-1をセット）する
      const idxStr = name.replace('subcontractor_name', ''); // 添字を取り出す
      this.catchInputInner({ name: `subcontractor_id${idxStr}`, type: 'number', value: -1 });
      this.catchInputInner(response, false);
    } else {
      // それ以外の場合は、そのまま
      this.catchInputInner(response);
    }
  }

  /**
   * 子コンポーネントからEmitされる値を親に渡す
   * @module catchInput
   * @param {any} response - 子コンポーネントより渡される値
   * @param {boolean} isUseParentRegistData - 親コンポーネントが保持するRegistDataを利用するか。
   * 1回の入力で複数項目を連続更新する場合は値の上書きを防ぐため、2つ目以降でfalseを設定する。デフォルトはtrue。
   * @return {void} - Emit
   */
  @Emit('catchInput')
  private catchInputInner(response: any, isUseParentRegistData = true) {
    if (this.parentRegistData && isUseParentRegistData) {
      this.registData = [...this.parentRegistData];
    }

    const name = response.name;
    const type = response.type;
    let value = response.value;
    // ToDo:フォームのデータタイプに合わせて整形する必要あり
    switch (type) {
      case 'text':
        break;
      case 'number':
        value = Number(value);
        break;
      case 'select':
        break;
      case 'textarea':
        break;
      case 'datetime':
        break;
    }
    const index = response.name.match(/[\d+]{1,}/);
    
    // "registData"にはoperation = 3（削除予定）のレコードも混じっているので、
    // 削除予定データの存在を考慮してデータ設定を行う
    if (this.registData.filter((e: any) => e.operation !== 3).length === 0) {
      // すべてのレコードが削除予定になっている
      this.registData.push({ operation : 1, item:{} });
    }

    const filtered = this.registData.filter((e: any) => e.operation !== 3);
    filtered[index].item[name.split('[')[0]] = value;
    this.sendData();
  
    return response;
  }
    
  /**
   * 子コンポーネントからEmitされた値をインサート・Update用に加工した物を親に渡す
   * @module sendData
   * @return {void} - Emit
   */
  @Emit('sendData')
  private sendData(){
    return this.registData;
  }
}
